import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mt-[100px] mb-48 w-full flex justify-center"
};
const _hoisted_2 = {
    key: 1,
    class: "default-grid md:mt-[50px]"
};
const _hoisted_3 = {
    key: 0,
    class: "lg:col-span-3"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
    key: 1,
    class: "filtering lg:col-span-12"
};
const _hoisted_6 = { key: 0 };
const _hoisted_7 = {
    key: 2,
    class: "flex flex-col lg:flex-row lg:justify-between lg:items-end gap-2 w-full"
};
const _hoisted_8 = { class: "flex gap-4 grow items-center lg:justify-end" };
const _hoisted_9 = { class: "key-label pb-1" };
const _hoisted_10 = { class: "flex items-center gap-2" };
const _hoisted_11 = { class: "text-sm" };
const _hoisted_12 = {
    key: 3,
    class: "mt-5 w-full flex justify-center"
};
const _hoisted_13 = {
    key: 4,
    class: "w-full mt-5"
};
const _hoisted_14 = {
    key: 5,
    class: "w-full mt-5"
};
const _hoisted_15 = {
    key: 6,
    class: "w-full mt-5"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ($setup.articlesStore.isLoadingStats || $setup.articlesStore.isLoadingGroups)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode($setup["LoadingSpinner"], { size: 32 })
        ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (!$setup.articlesStore.statsError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode($setup["ArticlesMenu"])
                ]))
                : _createCommentVNode("v-if", true),
            _createElementVNode("div", {
                class: _normalizeClass([!$setup.articlesStore.statsError ? 'lg:col-span-9 lg:col-start-4' : 'lg:col-span-12'])
            }, [
                ($setup.productsMainCategoriesElement)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        ref: "productsMainCategoriesRef",
                        innerHTML: $setup.productsMainCategoriesElement
                    }, null, 8 /* PROPS */, _hoisted_4))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", null, [
                            _createCommentVNode("    <MainSearch class=\"px-4\" />"),
                            (!$setup.articlesStore.isLoadingDetails)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createVNode($setup["ArticlesDetails"]),
                                    _createCommentVNode(" {{articlesStore.details}} ")
                                ]))
                                : _createCommentVNode("v-if", true),
                            (!$setup.isShortLengthsOverview)
                                ? (_openBlock(), _createBlock($setup["TabGroup"], {
                                    key: 1,
                                    selectedIndex: $setup.selectedTab,
                                    onChange: $setup.changeTab,
                                    class: "mb-5"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode($setup["TabList"], null, {
                                            default: _withCtx(() => [
                                                _createVNode($setup["Tab"], { class: "inverted-link" }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString($setup.$t(`All`)), 1 /* TEXT */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }),
                                                _createVNode($setup["Tab"], { class: "inverted-link" }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString($setup.$t(`Short lengths only`)), 1 /* TEXT */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                })
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["selectedIndex"]))
                                : _createCommentVNode("v-if", true),
                            (!$setup.articlesStore.isLoadingStats && !$setup.articlesStore.statsError)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createVNode($setup["ArticlesFilters"]),
                                    _createVNode($setup["ArticlesClearAllFilter"]),
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_9, _toDisplayString($setup.$t('Sort')), 1 /* TEXT */),
                                            _createElementVNode("div", _hoisted_10, [
                                                _createVNode($setup["ArticlesOrder"]),
                                                _createElementVNode("div", _hoisted_11, _toDisplayString($setup.$t('by')), 1 /* TEXT */),
                                                _createVNode($setup["ArticlesSort"])
                                            ])
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true),
                            ($setup.articlesStore.isLoadingItems)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createVNode($setup["LoadingSpinner"], { size: 32 })
                                ]))
                                : ($setup.articlesStore.itemsError)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                        _createVNode($setup["LoadingError"], {
                                            title: $setup.$t('Could not load articles, please try again')
                                        }, null, 8 /* PROPS */, ["title"])
                                    ]))
                                    : ($setup.articlesStore.items.length === 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                            _createVNode($setup["LoadingError"], {
                                                title: $setup.$t('No items found')
                                            }, null, 8 /* PROPS */, ["title"])
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.articlesStore.items, (article) => {
                                                return (_openBlock(), _createBlock($setup["ArticlesItem"], {
                                                    key: article.articleNumber,
                                                    item: article
                                                }, null, 8 /* PROPS */, ["item"]));
                                            }), 128 /* KEYED_FRAGMENT */)),
                                            _createVNode($setup["Pagination"], {
                                                startIndex: $setup.pagination.startIndex,
                                                currentItemCount: $setup.pagination.currentItemCount,
                                                itemsPerPage: $setup.pagination.itemsPerPage,
                                                totalItems: $setup.pagination.totalItems,
                                                pagingLinkTemplate: $setup.pagination.pagingLinkTemplate
                                            }, null, 8 /* PROPS */, ["startIndex", "currentItemCount", "itemsPerPage", "totalItems", "pagingLinkTemplate"])
                                        ]))
                        ])
                    ]))
            ], 2 /* CLASS */)
        ]));
}
